// extracted by mini-css-extract-plugin
export default {"iconCollections":"IconCollections_iconCollections__T+ZXB"};